module.exports = __webpack_public_path__ + "img/opening.9730ead0.png";